/* lua.js generated code 0.3.0 */

UserProduct = xClass("UserProduct")
var instance = null
UserProduct.getInstance = function () {
    if (!instance) {
        // if (__IOS) {
        //     instance = require("clover/logic/userProduct/UserProductTypeIOS").create()
        // } else if (__ANDROID) {
        //     instance = require("clover/logic/userProduct/UserProductTypeAndroid").create()
        // } else 
        if (META.platform == XcloverPlatform.wechatgame) {
            instance = require("clover/logic/userProduct/UserProductTypeWechatgame").create()
        } else if (__WIN32) {
            instance = require("clover/logic/userProduct/UserProductTypeWIN32").create()
        } else {
            instance = require("clover/logic/userProduct/UserProductTypeBase").create()
        }
    }
    return instance
}
